import { render, staticRenderFns } from "./ReportWidgetSettings.vue?vue&type=template&id=7d8b51e2&scoped=true"
import script from "./ReportWidgetSettings.vue?vue&type=script&lang=js"
export * from "./ReportWidgetSettings.vue?vue&type=script&lang=js"
import style0 from "./ReportWidgetSettings.vue?vue&type=style&index=0&id=7d8b51e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d8b51e2",
  null
  
)

export default component.exports